import React from 'react';
import NavbarButtonActive from "@/assets/NavbarButtonActive.svg";
import HamburgerMenu from "@/assets/HamburgerMenu.svg";

import OmegaIcon from './Omega Icon_RGB.png'
// import HamburgerMenu from './hamburger-menu.svg'
import OmegaIconForColourBackground from './Omega Icon_RGB_ForColourBackground.png'

const NavbarToggleButton = ({scrollY, active, onClick}) => {

  if(active) {
    if (scrollY > 0) {
      return <NavbarButtonActive onClick={onClick} width={49} height={49} />;
    } else {
      return <NavbarButtonActive onClick={onClick} width={49} height={49} />;
    }
  } else {
    if(scrollY > 0) {
      return <HamburgerMenu style={{marginTop: "16px"}} onClick={onClick} width={49} height={49} alt="" />
    } else {
      return <HamburgerMenu style={{marginTop: "16px"}} onClick={onClick} width={49} height={49} />
    }
  }
}

export default NavbarToggleButton